const locale = {
	TAB_OVERVIEW: 'Overview',
	TAB_MANAGER: 'Management',

	PERMISSIONS_SECTION_ROLES: 'Roles',
	PERMISSIONS_SECTION_DERIVED_ROLES: 'Derived Roles',
	PERMISSIONS_SECTION_ROLES_PERMISSIONS: 'Roles permissions',

	// #region Permissions Management fields
	DETAILS_PERMISSIONS_FIELD_ROLE: 'Role',
	DETAILS_PERMISSIONS_FIELD_ROLE_TITLE: 'Role title',
	DETAILS_PERMISSIONS_FIELD_ROLE_EXTERNAL: 'External',
	DETAILS_PERMISSIONS_FIELD_ROLE_LOGIN_REDIRECT_URL: 'Login redirect URL',
	DETAILS_PERMISSIONS_FIELD_PARENT_ROLE: 'Father role',
	DETAILS_PERMISSIONS_FIELD_CHILD_ROLE: 'Child role',
	DETAILS_PERMISSIONS_FIELD_RESOURCE: 'Resource',
	DETAILS_PERMISSIONS_FIELD_ACTION: 'Action',
	// #endregion

	DIALOG_PERMISSIONS_MANAGER_NEW_ROLE: 'New Role',
	DIALOG_PERMISSIONS_MANAGER_NEW_ROLE_RELATION: 'New derived Role',
	DIALOG_PERMISSIONS_MANAGER_NEW_ROLE_PERMISSION: 'New Permission'
};

export default locale;
